export default "__VITE_ASSET__CALQF1Ku__"